import { useContext, useEffect, useRef, useState } from 'react';
import { WebApiContext } from 'ascendon-web-api';
import { generateUnhandledFault, translateFault } from '../../helpers/faults';

function useProductData() {
  const [fault, setFault] = useState(null);
  const [uiModel, setUiModel] = useState(null);
  const WebApi = useContext(WebApiContext);

  const isMounted = useRef(true);

  useEffect(
    () => () => {
      isMounted.current = false;
    },
    [],
  );

  const requestProductData = ({
    productExternalReference,
    productExternalReferenceType,
    id = null,
  }) => {
    const getProductMetaDataApiCallHandler = (payload) => {
      WebApi.requestAll([
        {
          type: 'product',
          forceRefresh: false,
          payload: [payload],
        },
      ])
        .then((responses) => {
          if (isMounted.current) {
            const metadata = responses.data[0].data;
            setUiModel({ metadata });
          }
        })
        .catch((error) => {
          console.warn({ error });
          if (isMounted.current) {
            const code = error?.data?.Code || error?.data?.data?.Code;
            let errorMsg;
            if (!code) {
              const unknownFault = generateUnhandledFault(error.data);
              errorMsg = translateFault(unknownFault).translatedMessage;
              setFault(errorMsg);
            } else {
              errorMsg = translateFault(
                error.data.data || error.data,
              ).translatedMessage;
              setFault(errorMsg);
            }
          }
        });
    };

    if (id) {
      getProductMetaDataApiCallHandler({ Id: id });
    } else {
      getProductMetaDataApiCallHandler({
        ProductExternalReference: productExternalReference,
        ProductExternalReferenceType: productExternalReferenceType,
      });
    }
  };
  return [uiModel, fault, requestProductData];
}

export { useProductData };
export default useProductData;
